module.exports = __webpack_public_path__ + "386b7525d0ffc42650610f76e71d7a8a.jpg";